var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-author-rss"},[_c('el-button',{staticClass:"u-btn",class:{ 'u-fans-box': _vm.isSelf },attrs:{"size":"mini","plain":"","loading":_vm.loading,"disabled":_vm.isSelf},on:{"click":_vm.subscribe}},[_c('img',{staticClass:"u-icon",attrs:{"svg-inline":"","src":_vm.src}}),_vm._v(" "+_vm._s(_vm.btnText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }